import { formAddCsrfProtection } from "./utils";

function facebookConnect(form) {
	function handleResponse(response) {
		if (response.authResponse) {
			FB.api(
				`/${response.authResponse.userID}/`,
				{ fields: ["name", "email", "picture", "first_name", "last_name"] },
				(res) => {
					if (res && !res.error) {
						for (const input of form.querySelectorAll("input[name^='fb_']")) {
							const field_name = input.name.replace("fb_", "");
							if (field_name === "picture" && field_name in res) {
								form.querySelector('[name="fb_picture"]').value =
									res.picture.data.url;
							} else {
								form.querySelector(`[name="fb_${field_name}"]`).value =
									res[field_name];
							}
						}
						formAddCsrfProtection(form).then((data) => {
							form.submit();
						});
					}
				},
			);
		}
	}
	const perms = form.dataset.perms || "email,public_profile";
	FB.login(handleResponse, { scope: perms });
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	document
		.querySelector("#login-facebook a")
		?.addEventListener("click", (event) => {
			event.preventDefault();
			facebookConnect(event.target.closest("form"));
			return false;
		});
});
